import React, { useEffect, useState } from "react";
import silver_medal from "../assets/silver_medal.png";
import bronze_medal from "../assets/bronze_medal.png";
import icon1 from "../assets/payment_1.svg";
import icon2 from "../assets/payment_2.svg";
import icon3 from "../assets/payment_3.svg";
import AOS from 'aos';
import 'aos/dist/aos.css';
function MemberShip() {
  const [billingCycleWhite, setBillingCycleWhite] = useState("Monthly");
  const [billingCyclePurple, setBillingCyclePurple] = useState("Monthly");
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, [])
  return (
    <div id="memberships" className="bg-[#ebebeb?] flex flex-col items-center py-20">
      <div className="text-4xl text-center font-yeseva px-5">Memberships</div>
      <div className="text-lg text-center px-5 font-poppins pt-2 font-medium">
        Yearly membership will renew on 2023-01-21
      </div>
      <div className="w-full flex flex-col md:flex-row justify-center items-center gap-10 py-10 relative px-5">
        <div className="hidden md:block h-[300px] bg-white w-[90%] lg:w-[70%] absolute rounded-xl bottom-0"></div>

        {/* White Card */}
        <div data-aos="fade-up" className="bg-white rounded-2xl px-6 pb-7 shadow-2xl z-10">
          <div className="flex justify-between relative items-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center">
              <img src={bronze_medal} alt="" />
            </div>
            <div className="rounded-full bg-themeColor text-white px-8 text-lg py-1 font-poppins mt-4">
              Premium
            </div>
          </div>
          {/* Pricing */}
          <div className="mt-4 flex items-end gap-2 font-poppins">
            <h2 className="text-4xl font-extrabold">$89</h2>
            <p className="text-sm font-semibold">/month</p>
          </div>

          {/* Features */}
          <ul className="mt-4 space-y-2 font-poppins">
            <li className="flex items-center text-sm">
              <span className="mr-2">
                <img className="w-7" src={icon1} alt="" />
              </span>
              Unlimited profiles per day
            </li>
            <li className="flex items-center text-sm">
              <span className="mr-2">
                <img className="w-7" src={icon2} alt="" />
              </span>
              Review rejected profiles
            </li>
            <li className="flex items-center text-sm">
              <span className="mr-2">
                <img className="w-7" src={icon3} alt="" />
              </span>
              Like rejected profiles again
            </li>
          </ul>

          {/* Annual Pricing */}
          <div className="text-center mt-4">
            <p className="text-themeColor font-bold">
              $157 dollars{" "}
              <span className="text-gray-500 font-medium">/ Year</span>
            </p>
          </div>

          {/* Billing Cycle Switch for White Card */}
          <div className="flex justify-between mt-2 gap-3 rounded text-white bg-[#5A4685] p-0.5">
            {["Monthly", "Quarterly", "Yearly"].map((cycle) => (
              <button
                key={cycle}
                onClick={() => setBillingCycleWhite(cycle)}
                className={`px-3 py-1 text-sm rounded ${
                  billingCycleWhite === cycle && "bg-[#3D2869] text-white"
                }`}
              >
                {cycle}
              </button>
            ))}
          </div>
          <p className="text-xs text-center text-themeColor pt-2">
            (Save 2 months)
          </p>

          {/* Subscribe Button */}
          <div className="mt-6">
            <button className="w-full bg-themeColor text-white py-2 rounded-full text-lg font-semibold transition-all duration-300 hover:scale-105">
              Subscribe
            </button>
          </div>
        </div>

        {/* Purple Card */}
        <div data-aos="fade-down" className="gradientPurple rounded-2xl px-6 pb-7 shadow-2xl z-10">
          <div className="flex justify-between relative items-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center">
              <img src={silver_medal} alt="" />
            </div>
            <div className="rounded-full bg-[#988D25] text-white px-8 text-lg py-1 font-poppins mt-4">
              Platinum
            </div>
          </div>
          {/* Pricing */}
          <div className="mt-4 flex items-end gap-2 font-poppins text-white">
            <h2 className="text-4xl font-extrabold">$89</h2>
            <p className="text-sm font-semibold">/month</p>
          </div>

          {/* Features */}
          <ul className="mt-4 space-y-2 font-poppins text-white">
            <li className="flex items-center text-sm">
              <span className="mr-2">
                <img className="w-7" src={icon1} alt="" />
              </span>
              Unlimited profiles per day
            </li>
            <li className="flex items-center text-sm">
              <span className="mr-2">
                <img className="w-7" src={icon2} alt="" />
              </span>
              Review rejected profiles
            </li>
            <li className="flex items-center text-sm">
              <span className="mr-2">
                <img className="w-7" src={icon3} alt="" />
              </span>
              Like rejected profiles again
            </li>
          </ul>

          {/* Annual Pricing */}
          <div className="text-center mt-4">
            <p className="text-white font-bold">
              $157 dollars{" "}
              <span className="text-[#988D25] font-medium">/ Year</span>
            </p>
          </div>

          {/* Billing Cycle Switch for Purple Card */}
          <div className="flex justify-between mt-2 gap-3 rounded text-themeColor bg-white p-0.5">
            {["Monthly", "Quarterly", "Yearly"].map((cycle) => (
              <button
                key={cycle}
                onClick={() => setBillingCyclePurple(cycle)}
                className={`px-3 py-1 text-sm rounded ${
                  billingCyclePurple === cycle && "bg-[#988D25] text-white"
                }`}
              >
                {cycle}
              </button>
            ))}
          </div>
          <p className="text-xs text-center text-white pt-2">(Save 2 months)</p>

          {/* Subscribe Button */}
          <div className="mt-6">
            <button className="w-full bg-[#988D25] text-white py-2 rounded-full text-lg font-semibold transition-all duration-300 hover:scale-105">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemberShip;
